<template>
  <div
    class="author-picker"
  >
    <div>
      <label
        for="authors_select"
      >
        {{ authorsLbl }}
      </label>

      <select
        :name="inputName"
        id="authors_select"
        class="form-control"
        ref="authorsSelect"
        v-on:change="authorsChanged"
        multiple
      >
        <option
          v-for="author in authors"
          :value="author.id"
          :selected="isSelected(author.id)"
        >
          {{ author.name }}
        </option>
      </select>
      <div
        class="seach-authors"
      >
        <button
          type="button"
          class="btn btn-link"
          v-on:click="toggleSearch"
        >
          Search
        </button>

        <div
          class="form-group"
        >
          <div
            class="d-flex justify-content-between align-items-center"
            v-if="showSearch"
          >
            <div
              :class="authorsSearchInputClass"
            >
              <input
                type="search"
                id="authors_search"
                ref="authorsSearch"
                class="form-control px-0"
                placeholder="Search Authors"
                list="found-authors"
                v-model="authorsSearchQuery"
                v-on:keyup="searchAuthors"
                v-on:change="searchAuthors"
              />
              <datalist
                id="found-authors"
                v-on:input="addAuthor"
              >
                <option
                  v-for="author in foundAuthors"
                  data-author-id="author.id"
                  :value="foundAuthorLbl(author)"
                />
              </datalist>
            </div>
            <div
              class="col-1"
              v-if="foundAuthorSelected"
            >
              <input
                type="hidden"
                ref="foundAuthorId"
                :value="foundAuthorSelected.value"
              />
              <button
                type="button"
                class="btn btn-primary"
                v-on:click="addAuthor"
              >
                Add
              </button>
            </div>
          </div>
          <div
            class="alert alert-success text-center fade-out"
            v-if="showAuthorAdded"
          >
            Author selected! Please submit the form to update selected authors.
          </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      authorsSearchQuery: undefined,
      foundAuthors: [],
      foundAuthorSelected: false,
      showAuthorAdded: false,
      showSearch: false
    }
  },

  props: {
    authorsLbl: {
      type: String,
      default: 'Authors'
    },

    enableSearch: {
      type: Boolean,
      default: false
    },

    inputName: {
      type: String,
      default: 'author_ids'
    },

    selectedAuthorIds: {
      type: Array,
      default: () => []
    }
  },

  computed: mapState({
    base: state => state.base,
    authors: state => state.AuthorModule.authors,

    authorsSearchInputClass () {
      return `col-${this.foundAuthorSelected ? '11' : '12'}`
    }
  }),

  created () {
    this.get()
  },

  methods: {
    addAuthor () {
      const authorId = this.$refs.foundAuthorId.value

      let authorOptionNode = this.getAuthorNodeByAuthorId(authorId)
      authorOptionNode.selected = true
      this.showAuthorAdded = true
      this.authorsSearchQuery = ''

      this.authorsChanged()
      this.toggleSearch()
    },

    authorsChanged (ev) {
      const authorIds = [...this.$refs.authorsSelect.options].filter(
        option => option.selected
      ).map(option => option.value)

      this.$emit('authors-changed', authorIds)
    },

    foundAuthorLbl (author) {
      return author.name + (
        author.selected ? ' (Selected)' : ''
      )
    },

    isSelected (authorId) {
      return this.selectedAuthorIds.includes(authorId)
    },

    get () {
      this.$store.dispatch(
        `AuthorModule/getAuthors`
      ).catch(this.$root.processErrors)
    },

    getAuthorNodeByAuthorId (authorId) {
      return this.getDOMAuthorsOptions().find(opt => opt.value === authorId)
    },

    getAuthorByQuery (query) {
      return this.getDOMAuthorsOptions().find(
        opt => opt.innerText.trim() === query
      )
    },

    getAuthorsNodesByQuery (query) {
      return this.getDOMAuthorsOptions().filter(
        author => author.innerText.trim().toUpperCase().includes(
          query.toUpperCase()
        )
      )
    },

    focusSearch () {
      this.$refs.authorsSearch.focus()
    },

    searchAuthors (ev) {
      const query = this.$refs.authorsSearch.value.trim()
      this.foundAuthorSelected = this.getAuthorByQuery(query)

      if (!this.foundAuthorSelected) {
        this.foundAuthors = this.getAuthorsNodesByQuery(query).map(author => (
          {
            name: author.innerText.trim(),
            id: author.value,
            selected: this.isSelected(author.value)
          }
        ))
      }
    },

    getSuggestedAuthors () {
      return this.getDOMAuthors().join(',')
    },

    getDOMAuthors () {
      return this.getDOMAuthorsOptions().map(author => author.innerText.trim())
    },

    getDOMAuthorsOptions () {
      return Array.from(
        this.$refs.authorsSelect.options
      ).map(opt => opt)
    },

    toggleSearch () {
      this.showSearch = !this.showSearch

      if (this.showSearch && this.foundAuthorSelected) {
        this.showAuthorAdded = false
      }
    }
  }
}
</script>

<style scoped>
.author-picker select {
  height: 10rem;
}

.author-picker select,
.author-picker option {
  width: 100% !important;
}

.fade-out {
  animation-delay: 5s;
  animation-name: fadeOut;
  animation-duration: 1s;
  animation-fill-mode: forwards;
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    height: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AuthorPicker.vue